export default __webpack_public_path__ + "static/media/SG-Red-0006.3853272d.png";